export default {
  definitions: {
    presentation: require('./presentation').default,
  },
}



// WEBPACK FOOTER //
// ./src/content/installfest/addons/socialShare/index.js